(function() {
'use strict';

angular
    .module('TR')
    .directive('acceptanceText', function(insuranceService) {
        const domain = TRPCONFIG.Domain;
        return {
            restrict: 'A',
            link(scope, el) {
                scope.$watch('cm.booking.AcceptanceText', function() {
                    if (scope.cm.booking == null) {
                        return;
                    }

                    //various bad things happening here, all because the acceptance text is coming from the server in one block
                    if (scope.cm.insurance) {
                        const docPaths = insuranceService.getDocumentPaths();
                        $('a.showInsuranceTerms', el).attr('href', docPaths.PolicyWording).attr('target', '_blank');
                        $('a.showStatusDisclosure', el).attr('href', docPaths.Disclosure).attr('target', '_blank');
                        $('a.insuranceProductInformation', el).attr('href', docPaths.InsuranceProductInformation).attr('target', '_blank');
                    } else {
                        $('a.showInsuranceTerms', el).parent().hide();
                    }

                    function attachLightbox(e, url, content) {
                        e.preventDefault();
                        scope.cm.selectedImportantInfo = url;
                        scope.cm.showImportantInfo = true;
                        scope.cm.importantInfoContent = content || '';
                        scope.$apply();
                    }

                    $('a.agencyTerms', el).bind('click', function(e) {
                        attachLightbox(e, 'partials/popups/agencyterms');
                    });

                    const route = [domain.CultureCode, scope.cm.booking.BookingProcessId, scope.cm.booking.TermsData.Suppliers.join('|'), (scope.cm.booking.TermsData.TransferRateId || '')].join('/');

                    // Supplier Terms
                    let sup = '';
                    angular.forEach(scope.cm.booking.TermsData.Suppliers, function(s) {
                        sup += `&suppliers=${s}`;
                    });

                    const termsUrl = String.format('partials/terms/provider?cultureCode={0}&bookingProcessId={1}{2}&transferRateId={3}',
                        domain.CultureCode,
                        scope.cm.booking.BookingProcessId,
                        sup,
                        scope.cm.booking.TermsData.TransferRateId || '');

                    $('a.bookingTerms', el).attr('href', route).attr('target', '_blank');

                    $('a.bookingTerms', el).bind('click', function(e) {
                        attachLightbox(e, termsUrl);
                    });


                    if (scope.cm.flight) {
                        $('a.showFareRules', el).bind('click', function(e) {
                            const fareRulesText = _.get(scope.cm.flight, 'Details.SupplierFareRules', '');
                            attachLightbox(e, 'partials/popups/farerules', fareRulesText);
                        });
                    }
                });
            }
        };
    });
})();
